const userActionTypes = {
    TOKEN: 'TOKEN',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    CURRENT_PROJECT_ID: 'CURRENT_PROJECT_ID',
    GET_PROFILE: 'GET_PROFILE',
    GET_PROJECTS: 'GET_PROJECTS',
    GET_JWT_USER: 'GET_JWT_USER',
    RESET_TOKEN: 'RESET_TOKEN',
    SIGN_IN: 'SIGN_IN',
    SIGN_OUT: 'SIGN_OUT'
}

export default userActionTypes
